import { useLang } from '@/app/utils/useLang';
import styles from './index.module.scss';
import Link from 'next/link';

const JoinCommunity: React.FC = () => {
    const { t } = useLang('join_community');
    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            learnMore: 'https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2Fgroups%2Fdeltaprolaunch',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            learnMore: 'https://ca.ecoflow.com/',
        },
    ];
    return (
        <div className={styles.JoinCommunity}>
            {items.map((item) => {
                return (
                    <div className="item" key={item.title}>
                        <div className="title">{item.title}</div>
                        <div className="desc">{item.desc}</div>
                        <Link className="learnmore" href={item.learnMore} target="_blank">
                            learn more {'>'}
                        </Link>
                    </div>
                );
            })}
        </div>
    );
};

export default JoinCommunity;
